import Image from 'next/image'
export const IconsHomePage = () => {
  const icons = [
    { src: 'documenting.svg', alt: 'Documenting', text: 'Documenting' },
    { src: 'fingerprint.svg', alt: 'Identifying', text: 'Identifying' },
    { src: 'profile-edit.svg', alt: 'Profiling', text: 'Profiling' },
    { src: 'globe.svg', alt: 'Exposing', text: 'Exposing' },
  ]

  return (
    <div className="text-white md:py-[150px] sm:py-[80px] py-[40px] flex flex-wrap justify-center sm:gap-x-12 gap-x-8">
      {icons.map((icon, index) => (
        <div key={index} className="flex flex-col items-center animate-in fade-in slide-in-from-right-2 delay" style={{
          animationDelay: `${index * 0.3}s`,
          animationFillMode: 'both',
          animationDuration: '1.5s',
        }}>
          <Image className="mb-1" src={`/images/favicons/${icon.src}`} alt={icon.alt} width={25} height={25} />
          <p className="sm:text-base text-xs font-semibold">{icon.text}</p>
        </div>
      ))}
    </div>
  )
}
export default IconsHomePage
